// Package imports:
import React from "react";
// Component imports:
import Entrypoint from "../Entrypoint";
import PepWatchDisclaimerPage from "../../components/PEP/PepWatchDisclaimerPage";


const PepWatchDisclaimer: React.FC = () => {
  return (
    <Entrypoint>
        <PepWatchDisclaimerPage />
    </Entrypoint>
  );
};

export default PepWatchDisclaimer;
